import React, { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  FondwithoutGroupwiseFan,
  FundWithoutGroupWise,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Fund And Flow/FundAndFlow";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Loader } from "../../../../../components/Loader/Loader";
import { Download } from "lucide-react";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function WithOutGroup({ accountGroup, month }) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { WithoutGroupWisedata } = useSelector((state) => state.FundFlowSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");

  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(FondwithoutGroupwiseFan());
    dispatch(
      FundWithoutGroupWise({
        Firm,
        Year: YearId,
        selectedIds: accountGroup.join(","),
        IdxMonthNames: month,
      }),
    );
  }, [dispatch, Firm, YearId, accountGroup, month]);
  const getCrDetailRows = WithoutGroupWisedata?.CrDetail?.map(
    (item, index) => ({
      // srNumber: index + 1,
      acname: item.acname,
      Receipt: item.Receipt,
    }),
  );
  const getCrDetailColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Receipt Amount",
      key: "Receipt",
      format: true,
      align: "right",
    },
  ];

  const getDrDetailRows =
    WithoutGroupWisedata?.DrDetail?.map((item, index) => ({
      // srNumber: index + 1,
      acname: item?.acname ?? "-",
      Payment: item?.Payment ?? 0,
    })) || [];

  const getDrDetailColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Payment Amount",
      key: "Payment",
      format: true,
      align: "right",
    },
  ];

  const formatIndianRupee = (amount) =>
    amount
      ? new Intl.NumberFormat("en-IN", {
          currency: "INR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount)
      : "";

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Fund Flow Statement (Without Group)", pageWidth / 2, 15, {
      align: "center",
    });
    doc.line(marginX, 18, pageWidth - marginX, 18);

    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    let startY = 25;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    if (firmName) {
      doc.text(firmName, pageWidth / 2, startY, {
        align: "center",
      });
    }

    /* =====================================================
       1️⃣ RECEIPT DETAILS (CrDetail)
    ===================================================== */
    let yPos = 35;

    const receiptCols = [20, 130, 50];
    const receiptWidth = receiptCols.reduce((a, b) => a + b, 0);
    const receiptLeft = (pageWidth - receiptWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("RECEIPT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 6;

    let sr = 1;
    const receiptRows =
      WithoutGroupWisedata?.CrDetail?.map((r) => [
        sr++,
        r.acname || "",
        formatIndianRupee(r.Receipt),
      ]) || [];

    const receiptTotal = WithoutGroupWisedata?.CrDetail?.reduce(
      (sum, r) => sum + Number(r.Receipt || 0),
      0,
    );

    receiptRows.push(["", "TOTAL", formatIndianRupee(receiptTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: receiptLeft },
      head: [["Sr", "Account Name", "Receipt Amount"]],
      body: receiptRows,
      theme: "grid",

      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },

      // 👇 Add this
      columnStyles: {
        0: { halign: "center", cellWidth: receiptCols[0] },
        1: { cellWidth: receiptCols[1] },
        2: { halign: "right", cellWidth: receiptCols[2] },
      },

      didParseCell(data) {
        if (data.row.raw?.[1] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });
    /* =====================================================
       2️⃣ PAYMENT DETAILS (DrDetail)
    ===================================================== */
    doc.addPage();
    yPos = 30;

    const paymentCols = [20, 130, 50];
    const paymentWidth = paymentCols.reduce((a, b) => a + b, 0);
    const paymentLeft = (pageWidth - paymentWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("PAYMENT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 6;

    sr = 1;
    const paymentRows =
      WithoutGroupWisedata?.DrDetail?.map((r) => [
        sr++,
        r.acname || "",
        formatIndianRupee(r.Payment),
      ]) || [];

    const paymentTotal = WithoutGroupWisedata?.DrDetail?.reduce(
      (sum, r) => sum + Number(r.Payment || 0),
      0,
    );

    paymentRows.push(["", "TOTAL", formatIndianRupee(paymentTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: paymentLeft },
      head: [["Sr", "Account Name", "Payment Amount"]],
      body: paymentRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: paymentCols[0] },
        1: { cellWidth: paymentCols[1] },
        2: { halign: "right", cellWidth: paymentCols[2] },
      },
      didParseCell(data) {
        if (data.row.raw?.[1] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i}`, marginX, pageHeight - 5);
    }

    doc.save("Fund_Flow_Without_Group.pdf");
  };

  if (WithoutGroupWisedata === "no" || WithoutGroupWisedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  const cardStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
  };

  const labelStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
    padding: "14px",
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <Row className="g-3">
        {/* LEFT SIDE */}
        <Col lg={12} md={12} sm={12} xs={12}>
          <div style={cardStyle}>
            <div style={labelStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                }}
              >
                RECEIPT DETAILS
              </h2>
            </div>

            <FASTable
              data={getCrDetailRows}
              columns={getCrDetailColumns}
              externalTotals={WithoutGroupWisedata?.CrSummary?.[0] || {}}
            />
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col lg={12}>
          <div style={cardStyle}>
            <div style={labelStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                }}
              >
                PAYMENT DETAILS
              </h2>
            </div>

            <FASTable
              data={getDrDetailRows}
              columns={getDrDetailColumns}
              externalTotals={WithoutGroupWisedata?.DrSummary?.[0] || {}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
